import { useState, useContext, useEffect } from "react";
import { Box, Divider, Grid, Stack, Typography } from "@mui/material";
//Srcs
import "../../../Style/pagestyle.scss";

import { ButtonCreate } from "../../../Utils/Component";
import { AuthContext } from "../../../Context/AuthContext";
import { useGetMemberById } from "../../../Hooks/useGetMemberById";

import moment from "moment";
import ImageCard from "./ImageCard";
import MemberForm from "../../../Components/Member/Form/MemberForm";
import { useNavigate } from "react-router-dom";
import { formatPhoneNumber } from "../../../Function/DynamicFn";

const BoxFieldTitle = ({ title, value }) => (
  <>
    <Typography className="field-title">{title}</Typography>
    <Box
      sx={{
        width: "100%",
        height: "40px",
        bgcolor: "#F2F3F4",
        padding: "8.5px 14px",
        borderRadius: 1,
      }}
    >
      <Typography>{value}</Typography>
    </Box>
  </>
);

// Helper to determine error state class
export default function TabInfomation() {
  const { t } = useContext(AuthContext);

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(window.location.search);
  const id = queryParams.get("id");
  useEffect(() => {
    if (!id) {
      navigate("/member-in-mandate"); 
    }
  }, [id]);
  const { data, refetch } = useGetMemberById({ id });

  useEffect(() => {
    refetch();
  }, []);

  return (
    <>
      <Box>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <ButtonCreate
              handleOpen={handleOpen}
              classBtn={"btn-create"}
              classIcon={"icon-add"}
              title={t("update")}
            />

            {open && (
              <MemberForm
                open={open}
                handleClose={handleClose}
                setRefetch={refetch}
                dialogTitle="Update"
                editData={data}
              />
            )}
          </Grid>
        </Grid>
      </Box>

      <Box
        className="body-container"
        sx={{ bgcolor: "white", height: "100%", marginTop: "16px !important" }}
      >
        <Box padding={4}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent="center"
                    spacing={2}
                    sx={{ padding: 1 }}
                  >
                    <ImageCard image={data?.profile} />
                  </Stack>
                </Grid>

                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <Typography
                    className="field-title"
                    sx={{ fontWeight: "bold" }}
                  >
                    {t("thead_information")}
                  </Typography>
                  <Divider />
                </Grid>

                <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                  <BoxFieldTitle
                    value={data?.lastNameKh + " " + data?.firstNameKh}
                    title={t("thead_full_name")}
                  />
                </Grid>

                <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                  <BoxFieldTitle
                    value={data?.latinName}
                    title={t("thead_latin_name")}
                  />
                </Grid>

                <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                  <BoxFieldTitle value={data?.email} title={t("thead_email")} />
                </Grid>

                <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                  <BoxFieldTitle
                    value={formatPhoneNumber(data?.phoneNumber)}
                    title={t("thead_phone_number")}
                  />
                </Grid>

                <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                  <BoxFieldTitle
                    value={moment(data?.dateOfBirth).format("DD-MM-YYYY")}
                    title={t("thead_date_of_birth")}
                  />
                </Grid>

                <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                  <BoxFieldTitle
                    value={data?.nationalIdCardNumber}
                    title={t("thead_national_id_card_number")}
                  />
                </Grid>

                <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                  <BoxFieldTitle
                    value={data?.gender === "Male" ? t("thead_male") : t("thead_female")}
                    title={t("thead_gender")}
                  />
                </Grid>

                <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                  <BoxFieldTitle
                    value={data?.telegram}
                    title={t("thead_telegram")}
                  />
                </Grid>
                
                <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                  <BoxFieldTitle
                    value={data?.remark}
                    title={t("thead_remark")}
                  />
                </Grid>



                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <Typography
                    className="field-title"
                    sx={{ fontWeight: "bold" }}
                  >
                    {t("thead_current_address")}
                  </Typography>
                  <Divider />
                </Grid>

                <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                  <BoxFieldTitle
                    value={
                      data?.currentAddress?.capical_provinces_id
                        ?.capital_province_name_kh ||
                      data?.currentAddress?.capical_provinces_id
                        ?.capital_province_name_en ||
                      ""
                    }
                    title={t("thead_capital_province")}
                  />
                </Grid>

                <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                  <BoxFieldTitle
                    value={
                      data?.currentAddress?.district_municipalities_id
                        ?.district_municipality_name_kh ||
                      data?.currentAddress?.district_municipalities_id
                        ?.district_municipality_name_en ||
                      ""
                    }
                    title={t("thead_municipality_district")}
                  />
                </Grid>

                <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                  <BoxFieldTitle
                    value={
                      data?.currentAddress?.commune_sangkat_id
                        ?.commune_sangkat_name_kh ||
                      data?.currentAddress?.commune_sangkat_id
                        ?.commune_sangkat_name_en ||
                      ""
                    }
                    title={t("thead_commune_sangkat")}
                  />
                </Grid>

                <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                  <BoxFieldTitle
                    value={
                      data?.currentAddress?.village_id?.village_name_kh ||
                      data?.currentAddress?.village_id?.village_name_en ||
                      ""
                    }
                    title={t("thead_village")}
                  />
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <Typography
                    className="field-title"
                    sx={{ fontWeight: "bold" }}
                  >
                    {t("thead_place_of_birth")}
                  </Typography>
                  <Divider />
                </Grid>

                <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                  <BoxFieldTitle
                    value={
                      data?.placeOfBirth?.capical_provinces_id
                        ?.capital_province_name_kh ||
                      data?.placeOfBirth?.capical_provinces_id
                        ?.capital_province_name_en ||
                      ""
                    }
                    title={t("thead_capital_province")}
                  />
                </Grid>

                <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                  <BoxFieldTitle
                    value={
                      data?.placeOfBirth?.district_municipalities_id
                        ?.district_municipality_name_kh ||
                      data?.placeOfBirth?.district_municipalities_id
                        ?.district_municipality_name_en ||
                      ""
                    }
                    title={t("thead_municipality_district")}
                  />
                </Grid>

                <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                  <BoxFieldTitle
                    value={
                      data?.placeOfBirth?.commune_sangkat_id
                        ?.commune_sangkat_name_kh ||
                      data?.placeOfBirth?.commune_sangkat_id
                        ?.commune_sangkat_name_en ||
                      ""
                    }
                    title={t("thead_commune_sangkat")}
                  />
                </Grid>

                <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                  <BoxFieldTitle
                    value={
                      data?.placeOfBirth?.village_id?.village_name_kh ||
                      data?.placeOfBirth?.village_id?.village_name_en ||
                      ""
                    }
                    title={t("thead_village")}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </>
  );
}
